// Dependencies
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Dispatch } from "redux";
import { useFormik } from "formik";
import * as Yup from 'yup';
// @ts-ignore
import templateExcel from './../../../../../../assets/utils/formato-solicitud-caja-chica.xlsx';

// Infraestructure
import { addLoading, removeLoading } from "../../../../../shared/Infraestructure/SliceGenerico";
import { LanguageTranslate } from "../../../../../shared/Infraestructure/LanguageTranslate";
import { AdapterValidator } from "../../../../../shared/Infraestructure/AdapterValidator";
import { AdapterGenerico } from "../../../../../shared/Infraestructure/AdapterGenerico";
import { RootState } from "../../../../../shared/Infraestructure/AdapterStore";

// Domain
import { EntityConfigForm, EntityConfigModalFlujo, EntityConfigModalNotas, EntityNavBar, ModeForm, initEntityConfigForm, initEntityConfigModalFlujo, initEntityConfigModalNotas, keyModule, nameModule } from "../Domain/EntityUtils";
import { EntityDatosTarea } from "../../../../../shared/Domain/Catalogos/EntityProyectos";
import { EntityOT } from "../../../../../shared/Domain/Catalogos/EntityOT";
import { EntityRequestAddNote, EntityRequestCancelFlow, EntityRequestFormServiceSendApproval, initEntityRequestGenericForm } from "../Domain/EntityRequest";

// Adapter
import { AdapterConfigure } from "./AdapterConfigure";
import { RepositoryImplMain } from "./RepositoryImplMain";

// Application
import { UseCaseLoadInitialData } from "../Application/UseCaseLoadInitialData";
import { UseCaseFind } from "../Application/UseCaseFind";
import { EntityFlujoOT } from "../../../../../shared/Domain/Catalogos/EntityFlujoOT";
import { UseCaseAddNote } from "../Application/UseCaseAddNote";
import { UseCaseTemplatePDF } from "../Application/UseCaseTemplatePDF";
import { UseCaseSobregiroPendientes } from "../Application/UseCaseSobregiroPendientes";
import { EntityAnticipo } from "../../../../../shared/Domain/EntityAnticipo";
import { AdapterDataPermiss } from "../../../../../shared/Infraestructure/AdapterDataPermiss";
import { AdapterLoadMaster } from "../../../../../shared/Infraestructure/AdapterLoadMaster";

const languageTranslate = LanguageTranslate();
let nameStore: keyModule = '';
let modeForm: ModeForm = '';
let dataComplete: EntityAnticipo;

export const Controller = () => {
    const [configForm, setConfigForm] = useState<EntityConfigForm>(initEntityConfigForm)
    const [configModalFlujo, setConfigModalFlujo] = useState<EntityConfigModalFlujo>(initEntityConfigModalFlujo);
    const [configModalNotas, setConfigModalNotas] = useState<EntityConfigModalNotas>(initEntityConfigModalNotas);
    const { generico: { websocket, dbLocal }, auth: { user } } = useSelector((state: RootState) => state);
    const dispatch: Dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();

    const repository: RepositoryImplMain = new RepositoryImplMain(websocket, dbLocal, dispatch, AdapterConfigure.SCHEMA, AdapterConfigure.ENTITY);
    const repositoryLoadMaster = new AdapterLoadMaster(websocket, dbLocal, dispatch, AdapterConfigure.SCHEMA, AdapterConfigure.ENTITY);

    const formikForm = useFormik({
        initialValues: initEntityRequestGenericForm,
        onSubmit: () => {},
        validationSchema: Yup.object({
            OT: Yup.object().required(languageTranslate.moduloAnticipo.validate.errorOT).nullable(),
            Personal: Yup.object().required(languageTranslate.moduloAnticipo.validate.errorPersonal).nullable(),
            Divisa: Yup.object().required('Seleccione una Moneda').nullable(),
            Importe: Yup.number().min(1, languageTranslate.moduloAnticipo.validate.errorImporte).required(languageTranslate.moduloAnticipo.validate.errorImporte).nullable().test('ValidarImporte', languageTranslate.moduloAnticipo.validate.errorImporteValido, (value, context) => {
                if (!context.parent.Tarea) return true;
                const Tarea = context.parent.Tarea.dataComplete as EntityDatosTarea;
                const importeDisponible = Tarea.importe - Tarea.importeFacturado;
                if (importeDisponible < parseInt(`${value}`)) return false;
                return true;
            }),
            Banco: Yup.string().nullable(), //.required(languageTranslate.moduloAnticipo.validate.errorBanco).nullable(),
            CuentaBancaria: Yup.string().nullable(), //.required(languageTranslate.moduloAnticipo.validate.errorCuentaBancaria).nullable(),
            CuentaPaycard: Yup.string().nullable(),
            Descripcion: Yup.string().required(languageTranslate.moduloAnticipo.validate.errorNota).nullable(),
            Files: Yup.array().test('Validar Files', "Ingrese un Archivo", (value, context) => {
                if (!context.parent.OT) return true;
                const OT = context.parent.OT.dataComplete as EntityOT;
                const isCountryColombia = OT.DatosPais.CDPais === AdapterConfigure.CDPAIS_COLOMBIA;
                if (!isCountryColombia && value?.length === 0)  return false;

                return true;
            }).nullable()
        })
    });

    const init = () => {
        configModeType();
        AdapterGenerico.scrollTopByClassName('ViewAnticipoForm');
    };

    const configModeType = async () => {
        // Carga la información de los select
        const dataOptions = await new UseCaseLoadInitialData(repository).exec();

        // Variables
        let navBar: EntityNavBar[] = languageTranslate.moduloAnticipo.navBar;
        nameStore = 'SolicitudAnticipo';

        if (params.id) {
            // Modo editar
            modeForm = 'edit';
            const findForm = await new UseCaseFind(repository).exec(`${params.id}`, nameStore, dataOptions);
            if (!findForm) {
                AdapterGenerico.createMessage('Error', `No se encontró el detalle para: ${params.id}`, 'error').then(res => navigate(AdapterConfigure.LIST_ANTICIPO)); 
                return;
            }
            if (findForm.data.Estado.IdStatus !== 2) modeForm = 'preview';
            dataComplete = findForm.dataComplete;
            formikForm.setValues(findForm.data);
        } else {
            // Modo crear
            modeForm = 'create';
            formikForm.setFieldValue('Codigo', `${Date.now()}`);
            // Seleccionar OT Default
            if (user.DatosTrabajo.OT) {
                const [resultOT] = await onSearchOT(user.DatosTrabajo.OT)
                const resultEmpresa = dataOptions.empresas.find(row => row.dataComplete.CDSociedad === resultOT?.dataComplete.DatosEmpresa.CDEmpresa);
                formikForm.setFieldValue('OT', resultOT || null);
                formikForm.setFieldValue('Pais', resultOT?.dataComplete.DatosPais || null);
                formikForm.setFieldValue('Empresa', resultEmpresa || null);
                formikForm.setFieldValue('Delegacion', resultOT?.dataComplete.DatosTrabajo.Delegacion || null);
                const Divisa = dataOptions.moneda.find(row => row.dataComplete.Country.Code === resultOT?.dataComplete.DatosPais?.Code && !row.dataComplete.Key);
                formikForm.setFieldValue('Divisa', Divisa || null)

                // Seleccionar Personal Default
                const resultPersonal = {
                    TipoDocumento: user.TipoDocumento.TipoDocumento,
                    Identificacion: user.Identificacion,
                    ApellidoPaterno: user.LastNameFather,
                    ApellidoMaterno: user.LastNameMother,
                    Nombres: user.Name
                }

                formikForm.setFieldValue('Personal', resultPersonal)

                // Verifica el personal para obtener los datos del banco
                const result = await repository.findPersonal(user.Identificacion);
                if (!result) {
                    AdapterGenerico.createMessage('Error', `No se encontró el usuario: ${user.Identificacion}`, 'error').then(res => navigate(AdapterConfigure.LIST_ANTICIPO)); 
                    return;
                }

                /*if (!result.DatosBanco.CuentaCorriente) {
                    AdapterGenerico.createMessage('Error', `El usuario no tiene configurado su Cuenta Bancaria`, 'error').then(res => navigate(AdapterConfigure.LIST_ANTICIPO)); 
                    return;
                }*/

                formikForm.setFieldValue('Banco', result.DatosBanco.DatosPaycard?.Banco.Name || result.DatosBanco?.Banco?.Name || result.DatosBanco?.Banco?.Key || '');
                formikForm.setFieldValue('CuentaBancaria', result.DatosBanco?.CuentaCorriente || '');
                formikForm.setFieldValue('CuentaInterbancaria', result.DatosBanco?.CuentaInterbancaria || '');
                formikForm.setFieldValue('CuentaPaycard', result.DatosBanco?.DatosPaycard?.CuentaPaycard || '');
            }
        }

        // Modifica el navbar para el lenguaje
        if (navBar.length >= 3) navBar[2].text = nameModule[modeForm];

        // Verifica los permisos del usuario
        const { OT: OTPermissions } = AdapterDataPermiss.gerPermissByModule('rendicionesCajaChica');
        const ot = dataOptions.ot.filter(row => OTPermissions.includes(row.dataComplete.Code));

        // Guarda la información general y la del usuario
        setConfigForm(() => ({
            ...configForm,
            loadingForm: false,
            dataOptions: {
                ...dataOptions,
                ot
            },
            key: nameStore,
            navBar: navBar,
            mode: modeForm,
        }));

        formikForm.setFieldValue("User", { IdUser: user.IdUser, User: user.User, LastName: `${user.LastNameFather} ${user.LastNameMother}`, Name: user.Name, Perfil: user.Profile.find(row => row.Principal === 'SI')?.Perfil || '' })
    };

    const onChange = (name: string, value: any) => {

        switch (name) {
            case 'OT':
                if (!!value) {
                    const otSelected: EntityOT = value.dataComplete;
                    const resultEmpresa = configForm.dataOptions.empresas.find(row => row.dataComplete?.CDSociedad === otSelected?.DatosEmpresa?.CDEmpresa);
                    formikForm.setFieldValue('Pais', otSelected.DatosPais);
                    formikForm.setFieldValue('Empresa', resultEmpresa || null);
                    formikForm.setFieldValue('Delegacion', otSelected.DatosTrabajo.Delegacion);

                    const Divisa = configForm.dataOptions.moneda.find(row => row.dataComplete.Country.Code === otSelected.DatosPais?.Code && !row.dataComplete.Key);
                    formikForm.setFieldValue('Divisa', Divisa || null)
                } else {
                    formikForm.setFieldValue('Pais', null);
                    formikForm.setFieldValue('Empresa', null);
                    formikForm.setFieldValue('Delegacion', null);
                    formikForm.setFieldValue('Divisa', null)
                }
                formikForm.setFieldValue('Tarea', null)
                break;
            case 'Importe':
                formikForm.setFieldValue('Importe', AdapterGenerico.removerCeroIzquierda(value))
                return;
        }
        formikForm.setFieldValue(name, value);
    };

    const validateSobregiroPendiente = async (): Promise<boolean> => {
        console.log('Validando sobre giro pendiente para el usuario', user.Identificacion);
        const codePais = formikForm.values.Pais?.CDPais || formikForm.values.OT?.dataComplete?.DatosPais?.CDPais;
        if (codePais === '504') return true;


        const response = await new UseCaseSobregiroPendientes(repository).exec({
            user_identification: user.Identificacion
        });

        const importeCalculado = (response || []).reduce((total: number, row: any) => {
            const importe = Number(row?.DatosImporte?.Solicitud?.ImporteTotal || 0);
            return total + (Number.isNaN(importe) ? 0 : importe);
        }, 0);

        const importeSolicitud = Number(formikForm.values.Importe || 0);
        if (importeCalculado !== 0 && importeSolicitud < importeCalculado) {
            AdapterGenerico.createMessage(
                languageTranslate.textoAlerta,
                `El monto se la Solicitud debe ser mayor al monto de su Sobregiro pendiente + ${importeCalculado}`,
                'warning',
                false
            );
            return false;
        }

        return true;
    }

    const onSubmit = async (e: Event) => {
        try {
            e.preventDefault();
            e.stopPropagation();

            try { await formikForm.submitForm(); } catch (error) { }
            try { AdapterValidator.validate(await formikForm.validateForm()); } catch (error) { AdapterGenerico.createMessage(languageTranslate.textoIncompleto, (error as Error).message, 'warning', false); return null; }

            const isValidSobregiro = await validateSobregiroPendiente();
            if (!isValidSobregiro) return null;

            dispatch(addLoading({ textLoading: languageTranslate.textoCargando }));
            const dataFormatted = await repository.formatDataToSave(formikForm.values);
            await repository.save(dataFormatted, configForm.mode)

            dispatch(removeLoading());
            navigate(AdapterConfigure.LIST_ANTICIPO, { replace: true });
        } catch (error) {
            dispatch(removeLoading());
            AdapterGenerico.createMessage(languageTranslate.textoAlerta, (error as Error).message, 'warning', false);
        };
    };

    const onCancelForm = () => {
        navigate(AdapterConfigure.LIST_ANTICIPO);
    };

    /* =======================================CONFIG MODAL FLUJO======================================================== */

    const openModalFlujo = async () => {
        dispatch(addLoading({}));
        const flujoOT = await repositoryLoadMaster.findByPagination<any[]>(formikForm.values.OT?.dataComplete.Codigo, 'CTFlujosOT').catch(() => []);
        const flujoDelegacion = await repositoryLoadMaster.findByPagination<any[]>(formikForm.values.Delegacion?.Codigo, 'CTFlujosDelegacion').catch(() => []);
        setConfigModalFlujo(() => ({
            show: true,
            flujo: flujoOT.length > 0 ? flujoOT : flujoDelegacion,
            flujoSelected: undefined
        }));
        dispatch(removeLoading());
    }
    
    const closeModalFlujo = () => {
        setConfigModalFlujo(() => ({
            show: false,
            flujo: [],
            flujoSelected: undefined
        }));
    }

    const onChangeMFL = (flujo: EntityFlujoOT) => {
        setConfigModalFlujo((prev) => ({
            ...prev,
            flujoSelected: flujo
        }));
    }

    const onSubmitMFL = async (evt: Event) => {
        if (!configModalFlujo.flujoSelected) return AdapterGenerico.createMessage(languageTranslate.textoIncompleto, 'Seleccione un Flujo', 'warning', false);
        try {

            // Guardar Rendición
            try { await formikForm.submitForm(); } catch (error) { }
            try { AdapterValidator.validate(await formikForm.validateForm()); } catch (error) { AdapterGenerico.createMessage(languageTranslate.textoIncompleto, (error as Error).message, 'warning', false); return null; }

            const isValidSobregiro = await validateSobregiroPendiente();
            if (!isValidSobregiro) return null;

            if (formikForm.values.Pais.CDPais === AdapterConfigure.CDPAIS_COLOMBIA) {
                // Validación que tenga configurado cuenta bancaria
                if (!formikForm.values.CuentaBancaria && !formikForm.values.CuentaPaycard) throw Error(`El usuario no tiene configurado su Cuenta Bancaria`)

                // Validación tipo cuenta bancaria
                const codeMonedaSolicitud = formikForm.values.Divisa.dataComplete.Key;
                const codeMonedaLocal = "";
                if (codeMonedaSolicitud !== codeMonedaLocal) throw Error (`¡No tiene cuenta bancaria en ${formikForm.values.Divisa.label}!`)
            }

            dispatch(addLoading({ textLoading: languageTranslate.textoCargando }));
            const dataFormatted = await repository.formatDataToSave(formikForm.values);
            const responseSave = await repository.save(dataFormatted, configForm.mode)
            if (!responseSave) return;
            
            // Enviar a aprobación
            const dataApproval: EntityRequestFormServiceSendApproval = {
                paramsSend: {
                    idSolicitud: responseSave.IdSolicitud,
                    flujo: {
                        Id: configModalFlujo.flujoSelected.Id,
                        Codigo: configModalFlujo.flujoSelected.Codigo,
                        Code: configModalFlujo.flujoSelected.Code,
                        Name: configModalFlujo.flujoSelected.Name,
                        Descripcion: configModalFlujo.flujoSelected.Descripcion,
                        Aprobacion: configModalFlujo.flujoSelected.Aprobacion
                    },
                    user: {
                        IdUser: formikForm.values.User.IdUser,
                        LastName: formikForm.values.User.LastName,
                        Name: formikForm.values.User.Name,
                        User: formikForm.values.User.User,
                        Perfil: formikForm.values.User.Perfil
                    }
                },
                extraData: {
                    Codigo: responseSave.Codigo
                }
            }
            await repository.sendApproval(dataApproval);

            dispatch(removeLoading());
            navigate(AdapterConfigure.LIST_ANTICIPO, { replace: true });
        } catch (error) {
            dispatch(removeLoading());
            AdapterGenerico.createMessage(languageTranslate.textoAlerta, (error as Error).message, 'warning', false);
        };
    }

    const onCancelFlow = async () => {
        try {
            const result = await AdapterGenerico.createMessage('', '¿Desea cancelar el Flujo?', 'question', true);
            if (!result) return;
            dispatch(addLoading({ textLoading: languageTranslate.textoCargando }));
            const requestCancelFlow: EntityRequestCancelFlow = {
                codigo: formikForm.values.Codigo,
                user: {
                    IdUser: formikForm.values.User.IdUser,
                    LastName: formikForm.values.User.LastName,
                    Name: formikForm.values.User.Name,
                    Perfil: formikForm.values.User.Perfil,
                    User: formikForm.values.User.User
                }
            }
            await repository.cancelarFlow(requestCancelFlow);
            navigate(AdapterConfigure.LIST_ANTICIPO, { replace: true });
        } catch (error) {
            AdapterGenerico.createMessage(languageTranslate.textoAlerta, (error as Error).message, 'warning', false);
        } finally {
            dispatch(removeLoading());
        }
    }

    /* =======================================CONFIG MODAL NOTAS======================================================== */

    const openModalNotas = () => {
        setConfigModalNotas((prev) => ({
            nota: '',
            show: true,
            title: 'Notas'
        }))
    }

    const closeModalNotas = () => {
        setConfigModalNotas((prev) => ({
            nota: '',
            show: false,
            title: 'Notas'
        }))
    }

    const onChangeMNT = (_: string, value: string) => {
        setConfigModalNotas((prev) => ({
            ...prev,
            nota: value
        }))
    }

    const onSubmitMNT = async () => {
        try {
            if (configModalNotas.nota === '') return AdapterGenerico.createMessage('Incompleto', 'Ingrese un comentario', 'warning', false);
            
            dispatch(addLoading({ textLoading: languageTranslate.textoEnviando }))
            const payload: EntityRequestAddNote = {
                paramsSend: {
                    codigo: formikForm.values.Codigo || '',
                    nota: configModalNotas.nota
                },
                extraConfig: {
                    nameStore: nameStore
                }
            }

            let response = await new UseCaseAddNote(repository).exec(payload);

            if (response) {
                dataComplete.Notas = [
                    ...(dataComplete?.Notas || []),
                    response.data,
                ];
                (dataComplete.Dates as any) = { ...(dataComplete.Dates as any || {}), Update: response.data.Date };
                let templateNewNote = {
                    observacion: response.data.Description,
                    fecha: AdapterGenerico.convertDateToString(AdapterGenerico.convertStringToDate(response.data.Date.Date), 3),
                    usuario: `${response.data.User.Name} ${response.data.User.LastName}`,
                    action: "NUEVA NOTA"
                }
                formikForm.setFieldValue('Notas', [templateNewNote, ...formikForm.values.Notas]);
                await dbLocal.updateByIndexStore({ nameStore, value: dataComplete })
            }

            closeModalNotas()
        }  catch(error) {
            let msg = (error as Error).message;
            if (msg === 'error-date-update') {
                msg = `No se puede ${languageTranslate.moduloApprovals.question.textoDevolver}, el registro actualmente cuenta con modificaciones`
            }
            msg = `${msg} - ${formikForm.values?.Codigo}`
            AdapterGenerico.createMessage('Error', msg, 'error', false);
        } finally {
            dispatch(removeLoading());
        }
    }

    /* ======================================= Descargar Plantilla ======================================================= */
    const onDownload = async () => {
        if (!formikForm.values.OT) {
            AdapterGenerico.createMessage(languageTranslate.textoIncompleto, languageTranslate.moduloAnticipo.validate.errorOT, 'warning', false);
            return;
        }

        const cdPais = formikForm.values.OT?.dataComplete?.DatosPais?.CDPais;
        if (cdPais === '504') {
            AdapterGenerico.downloadDocument(templateExcel, 'Formato Solicitud Fondos.xlsx');
            return;
        }

        try {
            dispatch(addLoading({ textLoading: languageTranslate.textoDescargando }));

            const result = await new UseCaseTemplatePDF(repository).exec({
                Serie: '000-000',
                FechaStr: AdapterGenerico.convertDateToString(new Date(), 3),
                Importe: 0,
                RecibidoDe: '',
                CantidadEnLetras: '',
                Concepto: '',
                Efectivo: false,
                Cheque: false,
                Transferencia: true,
                NroCheque: '',
                Delegado: '',
                NombreRecibe: '',
                DNIRecibe: '',
                OT: '',
                Estado: 0,
            });

            if (!result) throw Error('No se pudo descargar la plantilla PDF');

            const uri = window.URL.createObjectURL(result);
            AdapterGenerico.downloadDocument(uri, 'Formato Solicitud Fondos.pdf');
            window.URL.revokeObjectURL(uri);
        } catch (error) {
            AdapterGenerico.createMessage(languageTranslate.textoAlerta, (error as Error).message, 'warning', false);
        } finally {
            dispatch(removeLoading());
        }
    }

    /** ==0 */
    const onSearchOT = async (text: string): Promise<any[]> => {
        const result = await repositoryLoadMaster.findByPagination<EntityOT[]>(text, 'CTOT').catch(() => []);
        const ot = result.map(row => ({ label: `${row.Codigo} - ${row.Name.trim()}`, value: row.Id, dataComplete: row }));

        setConfigForm((prev) => ({
            ...prev,
            dataOptions: {
                ...prev.dataOptions,
                ot
            }
        }))

        return ot;
    }

    return ({
        init,
        onSubmit,
        onCancelForm,
        onChange,
        configModeType,

        languageTranslate,
        configForm,
        formikForm,

        // Modal Flujo
        configModalFlujo,
        openModalFlujo,
        closeModalFlujo,
        onSubmitMFL,
        onChangeMFL,
        onCancelFlow,

        // Modal Notas
        configModalNotas,
        openModalNotas,
        closeModalNotas,
        onChangeMNT,
        onSubmitMNT,

        // Utils
        onDownload,
        onSearchOT,
    });
}